var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#2BD67B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6374 43.2182C29.7851 43.2953 29.9502 43.3345 30.1153 43.3332C30.2804 43.3319 30.4442 43.2914 30.5931 43.2129L35.3503 40.6699C36.6994 39.9508 37.7558 39.1467 38.5799 38.2106C40.3719 36.1709 41.3505 33.5677 41.333 30.8835L41.2767 22.0293C41.2713 21.0094 40.6015 20.0994 39.6108 19.7686L30.7609 16.7994C30.228 16.6189 29.6441 16.6229 29.1206 16.8085L20.3043 19.8837C19.319 20.2276 18.6613 21.1441 18.6667 22.1652L18.723 31.0129C18.7405 33.7011 19.7526 36.2925 21.5741 38.3112C22.4064 39.2343 23.4722 40.0266 24.8359 40.734L29.6374 43.2182ZM28.3781 32.8119C28.5767 33.0028 28.8345 33.0969 29.0922 33.0943C29.3499 33.093 29.6063 32.9962 29.8023 32.8027L35.0011 27.6774C35.3917 27.2917 35.3876 26.672 34.993 26.2915C34.597 25.911 33.9594 25.9136 33.5688 26.2993L29.0774 30.7264L27.2384 28.9587C26.8425 28.5783 26.2062 28.5822 25.8142 28.9679C25.4236 29.3536 25.4277 29.9733 25.8236 30.3538L28.3781 32.8119Z",
    fill: "#2BD67B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon3);
export default __webpack_public_path__ + "static/media/card_icon3.b245d3130ffe12955db3525c3b528b34.svg";
export { ForwardRef as ReactComponent };